import { styled } from 'styled-components';
import { useShallow } from 'zustand/react/shallow';

import { useStore } from '../../store/store';

import { DeviceListItem } from './DeviceListItem';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 16px;
  padding: 16px;
  max-width: 90%;
  margin: 0 auto;
`;

export const DeviceList = () => {
  const { devices } = useStore(
    useShallow((state) => ({
      devices: state.devices,
    })),
  );

  return (
    <Wrapper>
      {devices.map((device) => (
        <DeviceListItem device={device} key={device.id} />
      ))}
    </Wrapper>
  );
};
